module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/city/city.html
// module id = 527
// module chunks = 0